export default __webpack_public_path__ + "locales/lv/Files.json?hash=bfd78f62c05b927949569fb1c4933879";